module.exports = __webpack_public_path__ + "static/media/check.ef8cf18a.svg";